import { Button } from '@mui/material';
import { globalColors } from 'globalStyle';
import styled from 'styled-components';

export const LoginPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-content: start;
  justify-content: center;
`;
export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  min-height: 600px;
  width: 360px;
`;
export const ConfirmButton = styled(Button)`
  background-color: ${globalColors.regular.background.blue};
  color: ${globalColors.regular.text.white};
  margin-top: 20px;
`;
export const ErrorMessageWrapper = styled.div`
  display: flex;
  place-content: center;
  color: ${globalColors.regular.text.red};
`;
export const IconWrapper = styled.div`
  display: flex;
  place-content: center;
  margin-bottom: 50px;
`;
export const EmptyBox = styled.div`
  display: flex;
  min-height: 300px;
`;
export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
`;

export const DropdownList = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background-color: white;
  z-index: 10;
`;

export const DropdownItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover,
  &.selected {
    background-color: #f2f2f2;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
`;
